import React from 'react';
import { Box, BoxProps, Card, Flex, HStack } from '@chakra-ui/react';
import { Skeleton } from '@/components/ui/skeleton';

const invoiceHistoryChartSkeletonBars = [92, 126, 78, 148, 104, 166, 118, 138, 96, 156, 112, 132];

export const InvoiceHistoryChartSkeletonBody = () => (
  <Box height='200px' display='flex' flexDirection='column' gap={3}>
    <Flex flex='1' align='end' justify='space-between' gap='2' px='4' pb='4'>
      {invoiceHistoryChartSkeletonBars.map((height, index) => (
        <Skeleton key={index} height={`${height}px`} flex='1' maxW='40px' borderRadius='sm' />
      ))}
    </Flex>
    <HStack justify='center' gap='4' flexWrap='wrap'>
      {[0, 1, 2, 3].map((item) => (
        <HStack key={item} gap='2'>
          <Skeleton width='12px' height='12px' borderRadius='sm' />
          <Skeleton width='50px' height='14px' />
        </HStack>
      ))}
    </HStack>
  </Box>
);

export const InvoiceHistoryChartSkeleton = (props: BoxProps) => (
  <Card.Root w='full' minH='314px' {...props}>
    <Card.Header flexDirection='row' alignItems='center' justifyContent='space-between'>
      <Skeleton height='24px' width='160px' />
      <Skeleton height='40px' width='104px' borderRadius='md' />
    </Card.Header>
    <Card.Body h='250px' overflow='hidden'>
      <InvoiceHistoryChartSkeletonBody />
    </Card.Body>
  </Card.Root>
);
